// Light/dark theme handling (D-31). Persists choice; defaults to OS preference.

export type Theme = "light" | "dark";
const KEY = "medassist.theme";

export function getStoredTheme(): Theme | null {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" ? v : null;
}

export function resolveTheme(): Theme {
  return getStoredTheme() ?? (matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle("dark", theme === "dark");
  localStorage.setItem(KEY, theme);
}

export function applyInitialTheme(): void {
  document.documentElement.classList.toggle("dark", resolveTheme() === "dark");
}

export function toggleTheme(): Theme {
  const next: Theme = document.documentElement.classList.contains("dark") ? "light" : "dark";
  applyTheme(next);
  return next;
}
